// extracted by mini-css-extract-plugin
export default {"priceContent":"KilometresSlider_priceContent__vUF8m","button":"KilometresSlider_button__DAe73"};